const INIT_FILTER_VALUE = {
    filter_isOpen: false,
    search_isOpen: false,
    showDropdownSearch: false,
    provID: 0,
    ampID: 0,
    tambolID: 0,
    osm: 0,
};

const state = () => {
    return { ...INIT_FILTER_VALUE };
};

// actions
const actions = {
    filterIsOpen({ commit }) {
        commit("setFilterIsOpen");
    },
    searchIsOpen({ commit }) {
        commit("setSearchIsOpen");
    },
    showDropdownSearch({ commit }) {
        commit("setShowDropdownSearch");
    },
    resetAllProvData({ commit }) {

    }
};

// mutations
const mutations = {
    setFilterIsOpen(state, item) {
        state.filter_isOpen = item;
        state.search_isOpen = !item;
    },
    setSearchIsOpen(state, item) {
        state.search_isOpen = item;
        state.filter_isOpen = !item;
    },
    setShowDropdownSearch(state, item) {
        state.showDropdownSearch = item;
        state.filter_isOpen = item;
        state.search_isOpen = !item;
    },
    setProvID(state, item) {
        state.provID = item;
        state.ampID = 0;
        state.tambolID = 0;
    },
    setAmpID(state, item) {
        state.ampID = item;
        state.tambolID = 0;
    },
    setTambolID(state, item) {
        state.tambolID = item;
    },
    setOSM(state, item) {
        state.osm = item;
    },
    clearStore(state) {
        state = { ...INIT_FILTER_VALUE };
    },
};

// getters
const getters = {
    filter_isOpen: (state) => state.filter_isOpen,
    search_isOpen: (state) => state.search_isOpen,
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
